export const KEYS = {
  settings: 'plantpomo.settings.v1',
  sessions: 'plantpomo.sessions.v1',
  timer: 'plantpomo.timer.v1',
  ambient: 'plantpomo.ambient.v1',
  task: 'plantpomo.task.v1',
  entered: 'plantpomo.entered.v1',
} as const

export function load<T>(key: string, fallback: T): T {
  try {
    const raw = window.localStorage.getItem(key)
    if (!raw) return fallback
    const parsed = JSON.parse(raw) as T
    if (parsed === null || typeof parsed !== typeof fallback) return fallback
    if (Array.isArray(fallback) !== Array.isArray(parsed)) return fallback
    if (typeof fallback === 'object' && !Array.isArray(fallback)) {
      return { ...(fallback as object), ...(parsed as object) } as T
    }
    return parsed
  } catch {
    return fallback
  }
}

export function save<T>(key: string, value: T): void {
  try {
    window.localStorage.setItem(key, JSON.stringify(value))
  } catch {
    /* storage unavailable — the app still works for the current session */
  }
}

export function remove(key: string): void {
  try {
    window.localStorage.removeItem(key)
  } catch {
    /* ignore */
  }
}
